<template>
  <div class="details">
    <!-- 详情页 -->
    <div class="details_content">
      <QS-h3-title class="purchase" :title="titledetails">
        <el-button v-if="tabType" slot="right" @click="goBack">返回</el-button>
      </QS-h3-title>
      <el-tabs v-model="theOrder" type="card" class="TapTabs">
        <el-tab-pane
          v-for="(item, index) in theOrderList"
          :key="'theOrderList' + index"
          :name="item.name"
          :label="item.label"
        ></el-tab-pane>
      </el-tabs>
      <div v-if="theOrder === '0'">
        <!-- 订单信息 -->
        <OrderInformation v-loading="oLoading.search" />
      </div>
      <div v-if="theOrder === '1'">
        <!-- 收付款信息 -->
        <Receiptandpayment :tabType="tabType" />
      </div>
      <div v-if="theOrder === '2'">
        <!-- 支付计划 -->
        <PaymentPlan :orderId="orderId" />
      </div>
      <div v-if="theOrder === '5'">
        <!-- 退车信息 -->
        <ReturnInformation />
      </div>
    </div>
  </div>
</template>

<script>
import OrderInformation from '../components/Leaseorderdetails/orderInformation.vue'
import Receiptandpayment from '../components/Leaseorderdetails/ReceiptAndPayment/index'
import PaymentPlan from '../components/Leaseorderdetails/PaymentPlan'
import ReturnInformation from '../components/Leaseorderdetails/returnInformation.vue'
// eslint-disable-next-line import/no-cycle
import { getSubOrderDetail } from '@/api/domain/purchase.js' // 获取采购子订单详情
import selectOption from '@/store/dict/selectOptionDict'

export default {
  components: {
    OrderInformation,
    Receiptandpayment,
    PaymentPlan,
    ReturnInformation,
  },
  data() {
    return {
      orderType: '', // 用来区分是个人租赁订单详情还是企业租赁子订单详情 - 【personal】表示个人租赁订单;【enterChild】表示企业租赁子订单
      oLoading: {
        search: false,
      },
      theOrder: 0,
      // 展示退车信息type
      returnInfoType: 0,
      orderData: {},
      tabType: '', // 客户&车辆详情/个人租赁跳转到个人租赁详情的类型
      theOrderList: [
        {
          label: '订单信息',
          name: '0',
        },
        {
          label: '收付款信息',
          name: '1',
        },
        {
          label: '支付计划',
          name: '2',
        },
        {
          label: '退车信息',
          name: '5',
        },
      ],
    }
  },
  provide() {
    return {
      orderData: this.orderData,
      getDetails: this.getDetails,
    }
  },
  created() {
    const { id, tabType = '', orderType = '' } = this.$route.query
    this.tabType = tabType
    this.orderType = orderType || 'personal'
    if (id || id === 0) {
      this.orderId = id
    } else {
      this.$message.error('缺少ID参数')
      this.$router.go(-1)
      return
    }
    this.getDetails()
    // type 对应展示哪一个Tab
    const typecar = this.$route.query.type
    // 退车信息title展示
    this.returnInfoType = this.$route.query.returnInfoType || 0
    if (typecar === undefined) {
      this.theOrder = '0'
    } else {
      this.theOrder = String(typecar)
    }
    this.theOrder = String(this.theOrder)
  },
  computed: {
    titledetails() {
      const a = '采购子订单详情'
      if (this.theOrder === '5') {
        if (Number(this.returnInfoType) === 2) {
          return '发起退车解约'
        } else if (Number(this.returnInfoType) === 1) {
          return '核算确认'
        } else {
          return a
        }
      } else {
        if (this.theOrder === '0') {
          if (Number(this.$route.query.confirm) === 1) {
            return '租赁订单确认'
          } else {
            return a
          }
        }
        return a
      }
    },
  },
  methods: {
    // 返回上一级
    goBack() {
      this.$router.go(-1)
    },
    // 详情页请求数据
    async getDetails() {
      try {
        this.oLoading.search = true
        const { code, data } = await getSubOrderDetail({
          orderId: this.orderId,
        })
        this.oLoading.search = false
        if (code === 1) {
          const st = data.presentStartDate || ''
          const et = data.presentEntDate || ''
          if (st && et) {
            this.$set(this.orderData, 'freeCycle', `${st}~${et}`)
          } else {
            this.$set(this.orderData, 'freeCycle', '')
          }
          this.$set(this.orderData, 'orderId', this.orderId)
          this.$set(this.orderData, 'orderType', this.orderType) // 订单类型
          // 因为是引用类型，所以动态添加key
          if (data && Object.keys(data).length) {
            Object.keys(data).forEach((key) => {
              this.$set(this.orderData, key, data[key], '--')
            })
          }
          this.parseInfo(data)
        }
      } catch (error) {
        this.oLoading.search = false
      }
    },
    // 采购子订单详情--租赁信息--付款起止时间
    parseInfo(data) {
      const st = data.startDate || ''
      const et = data.endDate || ''
      if (st && et) {
        this.$set(this.orderData, 'payTimeRange', `${st}~${et}`)
      } else {
        this.$set(this.orderData, 'payTimeRange', '--')
      }
      this.$set(
        this.orderData,
        'serviceType',
        selectOption.serviceProviderTypeDict[data.serviceType],
      )
      this.$set(this.orderData, 'modelName', data.carModel)
      this.$set(
        this.orderData,
        'state',
        selectOption.purchaseOrderState[data.state],
      )
    },
  },
}
</script>
<style lang="scss" scoped>
.details {
  .details_content {
    .details_content_title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .purchase {
        margin: 0;
      }
      h3 {
        font-family: PingFangSC-Medium;
        font-size: 20px;
        color: #323233;
        font-weight: 500;
        margin: 0;
      }
    }
    .details_content_repeat {
      margin-bottom: 16px;
      ::v-deep .qs-h4-container-left {
        font-size: 16px;
      }
      .details_content_repeat_hundred {
        ::v-deep .column-title {
          text-align: right;
          padding-right: 10px;
          color: #333333;
          min-width: 115px !important;
        }
        .enclosure {
          ::v-deep .el-form-item__label {
            width: 140px !important;
          }
        }
      }
    }
    // 文件图标颜色
    .uptext {
      .blue {
        color: #2e7eff;
        display: inline-block;
        margin: 0;
      }
    }
  }
}
.TapTabs {
  margin-top: 20px;
}
</style>
